String.prototype.capitalizeEachWord = function () {
    const data = this //.trim()
    return data.charAt(0).toUpperCase() + data.slice(1, data.length)
};

String.prototype.ignoreAccent = function () {
    return this.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

String.prototype.removeSpecialCharacters = function () {
    return this.replace(/[^a-zA-Z0-9]/g, '');
}

String.prototype.capsEveryWord = function () {
    return this.replace(/(^\w|\s\w)/g, (match) => match.toUpperCase())
}